import LightDataGrid from '@/common/components/LightDataGrid/LightDataGrid';

export default LightDataGrid;
